<template>
    <v-container
        fluid
        class="transition-all"
    >
        <template v-if="testId">
            <ChallengeHeader v-if="showMobile" />
            <!-- esto en mobile -->
            <v-card :class="[showMobile ? 'ma-0' : '' , 'reading-card']">
                <ChallengeHeaderDesk v-if="!showMobile" /> <!--esto en desk-->
                <v-row class="position-relative">
                    <v-col
                        class="mx-auto position-relative"
                        id="main"
                        :style="`font-size:${
                            config ? config.fontSize : ''
                        }px !important;font-family:${mainFont}!important;`"
                    >
                        <v-row justify="center" align="center" class="position-relative">
                            <v-img
                                :src="readersSoundImageURL"
                                height="64px"
                                width="64px"
                                contain
                                class="main-sound-img cursor-pointer d-none d-md-block"
                                @click="playReading"
                            ></v-img>
                            <v-col cols="12" class="px-0">
                                <Highlightable
                                    :useHighlight="false"
                                    :useNotes="false"
                                    @dictionary="onDictionary"
                                    ref="highlightable"
                                >
                                    <v-card-text
                                        data-cy="mainContainer-title"
                                        class="justify-center text-h4 mb-10 mt-4"
                                        style="color: #4a3216;"
                                    >
                                        {{ text_name }}
                                    </v-card-text>
                                    <div
                                        v-for="(page, index) in pages"
                                        :key="index"
                                        :style="{
                                    fontSize: `${config ? config.fontSize : ''}px !important`,
                                    fontFamily: `${mainFont}!important`,
                                    color: '#4a3216',
                                    lineHeight: '1.5',
                                    display: 'flex',
                                    justifyContent: 'center'
                                }"
                                    >
                                        <ChallengePage
                                            :texts="page"
                                            :page-number="index + 1"
                                            v-if="challengePage === index + 1"
                                            :active="challengePage === index + 1"
                                        />
                                    </div>
                                </Highlightable>
                            </v-col>
                        </v-row>
                        <audio id="audio_zen" v-show="false">
                            <source
                                v-for="(track, index) of global.ZEND_SOUNDS"
                                :key="index"
                                :data-track-number="index"
                                :src="`${global.ZEND_MUSIC_URI}${track}`"
                                type="audio/mpeg"
                            />
                        </audio>

                        <div class="w-100">
                            <ChallengeFooter
                                :current-page="challengePage"
                                :total-pages="pages.length"
                                :is-last-page="challengePage === pages.length"
                                @next="nextPage"
                                @back="previousPage"
                                @finish="showQuestion"
                            />
                        </div>
                    </v-col>
                    <UtilsPanel
                        class="position-fixed"
                        v-if="!showMobile"
                    />
                </v-row>
            </v-card>
        </template>
    </v-container>
</template>

<script>
import { mapState, mapActions } from 'vuex'

import Highlightable from '@/components/reading/core/Highlightable.vue'
import global from '@/constants/GlobalConstant'
import ChallengePage from './ChallengePage.vue'
import ChallengeFooter from './ChallengeFooter.vue'
import ChallengeHeader from './ChallengeHeader.vue'
import Markjs from '../../../mixins/Markjs'
import UtilsPanel from './UtilsPanel.vue'
import ChallengeHeaderDesk from './ChallengeHeaderDesk.vue'
const PAGES_PARTS = 3

export default {
    components: {
        UtilsPanel,
        Highlightable,
        ChallengePage,
        ChallengeFooter,
        ChallengeHeader,
        ChallengeHeaderDesk,
    },
    data: () => ({
        selectedText: '',
        global,
        zenIndex: 0,
        urlAssets: process.env.VUE_APP_BEEREADERS_ASSETS_URL,
        loading:false,
        snackbar: false,
        soundpauseicon: require('@/assets/img/icons/icon-voice-assistant-select.svg'),
        soundplayicon: require('@/assets/img/icons/icon-voice-assistant.svg'),
    }),
    methods: {
        ...mapActions('challenge', [
            'ShowQuestion',
            'setReadingTime',
            'setReReadingTime',
            'updateConfig',
            'increasePage',
            'decreasePage',
        ]),
        ...mapActions('bookReading', [
            'showDictionary',
            'setDictionaryMode',
            'setWord',
        ]),
        showQuestion() {
            this.ShowQuestion()
            if (this.stShowQuestions || this.stShowQuestionsMobile) {
                this.setReadingTime(new Date().getTime() - this.tiempoEmpleadoLectura)
                if (this.tiempoEmpleadoReLectura !== 0) {
                    this.setReReadingTime(new Date().getTime() - this.tiempoEmpleadoReLectura)
                }
            } else {
                this.setReadingTime(new Date().getTime() + this.tiempoEmpleadoLectura)
                if (this.tiempoEmpleadoReLectura !== 0) {
                    this.setReReadingTime(new Date().getTime() + this.tiempoEmpleadoReLectura)
                }
            }
        },
        nextPage() {
            if (this.challengePage < this.pages.length) this.increasePage()
        },
        previousPage() {
            if (this.challengePage > 1) this.decreasePage()
        },
        timeout(ms = 1000) {
                return new Promise(resolve => setTimeout(resolve, ms));
        },
        async onDictionary(text) {
            const clean = text.replace(' ', ',')
            const arr = clean.split(',')
            this.resetVars()
            if (arr.length > 1 && arr[1]) {
                this.$modal.warning(this.$t('bookReading.warnDictionary'))
                return
            }
            await this.timeout(1000);
            this.setDictionaryMode('auto')
            this.setWord(arr[0])
            this.showDictionary()
        },
        resetVars() {
            this.selectedText = ''
            this.$refs.highlightable.resetVars()
        },
        playBackgroundMusic() {
            const audioZen = document.getElementById('audio_zen')
            const vm = this
            if (audioZen) {
                const songURL = audioZen.children[this.zenIndex].src

                audioZen.setAttribute('src', songURL)
                audioZen.onended = () => {
                    vm.zenIndex += 1
                    if (audioZen.children.length < vm.zenIndex) {
                        vm.zenIndex = 0
                    }
                    const nextSong = audioZen.children[this.zenIndex].src
                    audioZen.setAttribute('src', nextSong)
                    setTimeout(() => audioZen.play(), global.ZEND_PLAY_DELAY)
                }
                if (this.challengeSoundActive) setTimeout(() => audioZen.play(), global.ZEND_PLAY_DELAY)
                else this.pausePlayer(audioZen)

                this.updateConfig(this.user.id)
            }
        },
        pausePlayer(player) {
            player.pause()
        },
        setVolume(vol) {
            const audioZen = document.getElementById('audio_zen')
            if (audioZen) audioZen.volume = vol / 100
            this.updateConfig(this.user.id)
        },
        playReading() {
            this.readerSound = !this.readerSound;
            this.readCurrentText(false);
        },
    },
    computed: {
        ...mapState({
            user_loaded: (state) => state.userData.user_loaded,
            user_id: (state) => state.userData.user.id,
            user: (state) => state.userData.user,
            controlsTexts: (state) => state.challenge.controlsTexts,
            challengePage: (state) => state.challenge.challengePage,
            text_name: (state) => state.challenge.textName,
            evaluationId: (state) => state.challenge.evaluationId,
            challengeCategories: (state) => state.challenge.challengeCategories,
            coins: (state) => state.userData.coins,
            categories: (state) => state.categories,
            sound: (state) => state.challenge.config.soundVol,
            tiempoEmpleadoLectura: (state) => state.challenge.tiempoEmpleadoLectura,
            tiempoEmpleadoReLectura: (state) => state.challenge.tiempoEmpleadoReLectura,
            config: (state) => state.challenge.config,
            challengeSoundActive: (state) => state.challenge.config.soundActive,
            stShowQuestions: (state) => state.challenge.showQuestion,
            stShowQuestionsMobile: (state) => state.challenge.mobileShowQuestions,
            testId: (state) => state.challenge.testId,
            showMobile: (state) => state.isMobile,
        }),
        playSound() {
            return this.challengeSoundActive
        },
        _volume() {
            return this.sound
        },
        contextual_image() {
            if (!this.challengeCategories || !this.challengeCategories.length) return 'default.jpg'

            const userBirthdate = this.$moment(this.user.birthDate, 'YYYY')
            const diff = this.$moment().diff(userBirthdate, 'years')
            const category = this.challengeCategories[
                Math.floor(Math.random() * this.challengeCategories.length)
            ]
            if (category) {
                const mainCategory = this.categories.find((el) => {
                    return el.id === category.lbMetaDataCategoryId
                })
                if (mainCategory) {
                    const image = mainCategory.categoryContextualImageDTOList.find(
                        (el) =>
                            diff >= el.bookCategorizationAgeRangeDTO.fromAge &&
                            diff <= el.bookCategorizationAgeRangeDTO.toAge
                    )

                    if (image) {
                        return `${image.resourceDir}.png`
                    }
                } else return 'default.jpg'
            }
            return 'default.jpg'
        },
        mainFont() {
            switch (this.config.typography) {
                case '0':
                    return "'Poppins', sans-serif"
                case '1':
                    return "'Roboto', sans-serif"
                case '2':
                    return "'Comic Sans MS', arial"
                case '3':
                    return "'Arial', fantasy"
                default:
                    return 'Arial'
            }
        },
        pages() {
            const { controlsTexts } = this
            return this.$utils.divideArrayInEqualsParts(controlsTexts, PAGES_PARTS)
        },
        readersSoundImageURL() {
            return this.isNarratorActive ? this.soundpauseicon : this.soundplayicon
        }
    },
    mounted() {
        if (this.playSound) {
            this.playBackgroundMusic()
        }
    },
    async beforeDestroy() {
        await this.removeChallengeAudio()
    },
    watch: {
        playSound() {
            this.playBackgroundMusic()
        },
    },
    mixins: [Markjs]
}
</script>

<style scoped>
.nuevo {
    border-width: 1px;
    border-color: blue;
}
.main-sound-img{
    position: absolute;
    left: 3.5em;
    top: 1em;
    z-index: 1
}

.reading-card{
    margin: 0;
    @media screen and (min-width: 768px) {
        margin: 0 5em 0 1em;
        width: calc(100% - 6em);
    }
}
.util-bar{
    @media screen and (max-width: 767px) {
        display: none;
    }
}
</style>
